export default "__VITE_ASSET__BT7nloW0__"